"use strict";
const React = require('react');
const react_redux_1 = require('react-redux');
const play_circle_outline_1 = require('material-ui/svg-icons/av/play-circle-outline');
const pause_circle_outline_1 = require('material-ui/svg-icons/av/pause-circle-outline');
const tasks_1 = require('../actions/tasks');
const c = require('./theme/colors');
const RaisedButton_1 = require('./RaisedButton');
const mapDispatchToProps = (dispatch) => ({
    startTask: (task) => dispatch(tasks_1.startTask(task)),
    stopTask: (task) => dispatch(tasks_1.stopTask(task)),
});
const handleStartTask = (props) => {
    props.startTask(props.task);
    if (props.onStartTask) {
        props.onStartTask(props.task);
    }
};
const handleStopTask = (props) => {
    props.stopTask(props.task);
    if (props.onStopTask) {
        props.onStopTask(props.task);
    }
};
const StartTaskButton = (props) => {
    const { task } = props;
    const activeSession = task.activeSession;
    const buttonStyle = Object.assign({}, style.button, props.style);
    if (activeSession) {
        return (React.createElement(RaisedButton_1.default, {onTouchTap: () => handleStopTask(props), style: buttonStyle}, 
            React.createElement("div", {style: { color: c.white }}, 
                React.createElement(pause_circle_outline_1.default, {style: style.playPauseIcon}), 
                React.createElement("span", {style: style.text}, "Pause"))
        ));
    }
    else {
        return (React.createElement(RaisedButton_1.default, {onTouchTap: () => handleStartTask(props), style: buttonStyle}, 
            React.createElement("div", {style: { color: c.white }}, 
                React.createElement(play_circle_outline_1.default, {style: style.playPauseIcon}), 
                React.createElement("span", {style: style.text}, "Start"))
        ));
    }
};
const style = {
    button: {
        minWidth: '105px',
    },
    playPauseIcon: {
        display: 'inline-block',
        fill: c.white,
        height: '24px',
        width: '24px',
        transition: 'all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms',
        verticalAlign: 'middle',
        marginLeft: '12px',
        marginRight: 0,
    },
    text: {
        fontSize: '14px',
        letterSpacing: 0,
        fontWeight: 500,
        margin: 0,
        paddingLeft: '8px',
        paddingRight: '16px',
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = react_redux_1.connect(state => state, mapDispatchToProps)(StartTaskButton);



/** WEBPACK FOOTER **
 ** ./src/components/StartTaskButton.tsx
 **/